import { PropsWithChildren } from "react";

import { PortalSubNavigation } from "./PortalSubNavigation";

type Props = PropsWithChildren;

export const PortalSubNavigationTabs = ({ children }: Props) => {
  return (
    <PortalSubNavigation>
      <div
        style={{
          padding: "0 24px",
          backgroundColor: "var(--background-default-primary)",
          borderBottom: "1px solid var(--border-default-primary)",
          display: "flex",
          alignItems: "flex-end",
          width: "100%",
          boxSizing: "border-box",
        }}
      >
        {children}
      </div>
    </PortalSubNavigation>
  );
};